import React, { useEffect, useRef } from 'react';

const SporeField = () => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext('2d');
    let raf;
    let w, h;
    const mouse = { x: -9999, y: -9999 };

    const resize = () => {
      w = canvas.width = canvas.offsetWidth * devicePixelRatio;
      h = canvas.height = canvas.offsetHeight * devicePixelRatio;
    };
    resize();
    window.addEventListener('resize', resize);

    const css = getComputedStyle(document.documentElement);
    const neonT = (css.getPropertyValue('--neon').trim() || '16 185 129').replace(/\s+/g, ',');
    const cyberT = (css.getPropertyValue('--cyber').trim() || '6 182 212').replace(/\s+/g, ',');

    const N = 70;
    const spores = Array.from({ length: N }, () => ({
      x: Math.random() * (canvas.offsetWidth || 1200),
      y: Math.random() * (canvas.offsetHeight || 700),
      vx: (Math.random() - 0.5) * 0.25,
      vy: (Math.random() - 0.5) * 0.25,
      r: Math.random() * 1.8 + 0.6,
      hue: Math.random() > 0.75 ? 'cyan' : 'emerald',
    }));

    const onMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    };
    window.addEventListener('mousemove', onMove);

    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.save();
      ctx.scale(devicePixelRatio, devicePixelRatio);
      const W = canvas.offsetWidth;
      const H = canvas.offsetHeight;

      for (const s of spores) {
        const dx = s.x - mouse.x;
        const dy = s.y - mouse.y;
        const d = Math.hypot(dx, dy);
        if (d < 120 && d > 0.01) {
          s.vx += (dx / d) * 0.05;
          s.vy += (dy / d) * 0.05;
        }
        s.vx *= 0.985;
        s.vy *= 0.985;
        s.x += s.vx;
        s.y += s.vy;
        if (s.x < 0 || s.x > W) s.vx *= -1;
        if (s.y < 0 || s.y > H) s.vy *= -1;
      }

      for (let i = 0; i < N; i++) {
        for (let j = i + 1; j < N; j++) {
          const a = spores[i];
          const b = spores[j];
          const d = Math.hypot(a.x - b.x, a.y - b.y);
          if (d < 110) {
            ctx.strokeStyle = `rgba(${neonT},${(1 - d / 110) * 0.16})`;
            ctx.lineWidth = 0.6;
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.stroke();
          }
        }
      }

      for (const s of spores) {
        ctx.beginPath();
        ctx.fillStyle = s.hue === 'cyan' ? `rgba(${cyberT},0.8)` : `rgba(${neonT},0.8)`;
        ctx.shadowColor = s.hue === 'cyan' ? `rgb(${cyberT})` : `rgb(${neonT})`;
        ctx.shadowBlur = 8;
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fill();
        ctx.shadowBlur = 0;
      }
      ctx.restore();
      raf = requestAnimationFrame(tick);
    };
    tick();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
      window.removeEventListener('mousemove', onMove);
    };
  }, []);

  return <canvas ref={ref} data-testid="spore-canvas" className="absolute inset-0 h-full w-full opacity-70" />;
};

export default SporeField;
